import { APP_BASENAME } from '@/config';

/**
 * 构建内部路由完整URL，自动添加APP_BASENAME前缀
 */
export function buildInternalUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return APP_BASENAME ? `${APP_BASENAME}${normalizedPath}` : normalizedPath;
}

/**
 * 打开内部路由新窗口，自动处理APP_BASENAME前缀
 */
export function openInternalWindow(
  path: string, 
  target: string = '_blank', 
  features?: string
): Window | null {
  return window.open(buildInternalUrl(path), target, features);
}

/**
 * 检查URL是否为内部路由
 */
export function isInternalUrl(url: string): boolean {
  return url.startsWith('/') && !url.includes('://');
} 